import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CgClose } from "react-icons/cg";

export const Wrapper = styled("div")(() => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 800,
}));

export const Header = styled("header")(() => ({
  backgroundColor: "#fff",
  padding: "4px 10px",
  textAlign: "end",
  borderRadius: "4px 4px 0 0",
  borderBottom: "1px solid #e4e7ec",
}));

export const Footer = styled("footer")(() => ({
  backgroundColor: "#fff",
  padding: "5px 10px",
  textAlign: "center",
  font: "600 12px/24px Manrope",
  borderRadius: "0 0 4px 4px",
  borderTop: "1px solid #e4e7ec",
}));

export const ImgBox = styled(Box)(({ isLoading }: { isLoading: boolean }) => ({
  maxWidth: 600,
  minWidth: isLoading ? 600 : "100%",
  minHeight: isLoading ? 400 : "100%",
  backgroundColor: isLoading ? "#F1f1f1" : "transparent",
}));

export const CloseIcon = styled(CgClose)(() => ({
  fontSize: 16,
  marginTop: 5,
  cursor: "pointer",
}));

interface ButtonProps {
  isDisabled: boolean;
  position: string;
}
export const Button = styled("span")(({ isDisabled, position }: ButtonProps) => ({
  position: "absolute",
  height: "30px",
  width: "30px",
  top: "50%",
  [position]: "-35px",
  backgroundColor: isDisabled ? "#E4E7EC" : "#EDF5FB",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: isDisabled ? "normal" : "pointer",
  font: "600 24px/21px Manrope",
  color: isDisabled ? "#98A2B3" : "#308CDB",
  transform: "translate(0, -50%)",
}));
